import { TipoPagamentoViagem } from "../enums/TipoPagamentoViagem";

export const PagamentoLabel = new Map<number, string>([
  [TipoPagamentoViagem.Pix, "Pix"],
  [TipoPagamentoViagem.CartaoCredito, "Cartão de Crédito"],
]);